import type { SupabaseClient } from '@supabase/supabase-js';

export const CRM_OPPORTUNITY_READ_ON_ACTIVITY_EVENT = 'crmOpportunityReadOnActivity';

/** Persist `is_unread: false` for a pipeline opportunity. */
export async function persistOpportunityRead(
  supabase: SupabaseClient,
  opportunityId: number,
  businessId?: string
): Promise<void> {
  let query = supabase
    .from('pipeline_opportunities')
    .update({ is_unread: false })
    .eq('id', opportunityId);

  if (businessId) {
    query = query.eq('business_id', businessId);
  }

  const { error } = await query;
  if (error) {
    console.error('Error marking opportunity as read:', error);
    throw error;
  }
}

/** Mark one or more opportunities read after CRM activity and notify UI listeners. */
export async function markOpportunitiesReadOnActivity(
  supabase: SupabaseClient,
  opportunityIds: number[],
  businessId?: string,
): Promise<void> {
  const uniqueIds = [...new Set(opportunityIds.filter((id) => Number.isFinite(id)))];
  if (!uniqueIds.length) return;

  await Promise.all(
    uniqueIds.map((opportunityId) => persistOpportunityRead(supabase, opportunityId, businessId)),
  );

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(CRM_OPPORTUNITY_READ_ON_ACTIVITY_EVENT, {
        detail: { opportunityIds: uniqueIds, businessId },
      }),
    );
  }
}
